module.exports = "https://cdn.realtymogul.com/static/media/img_panel_white_apts.69e5f437.jpg";